import { useTranslation } from 'react-i18next'

const Translate = (word: string) => {

    const { t } = useTranslation()

    return <>{t(word)}</>
}

const useTranslateHelper = () => {


    return useTranslation()
}

export { Translate as t, useTranslateHelper }